<template>
  <ablauf-seite
    ablauf="lauf.test"
    :knopf-laufart="laufart"
    :knopf-text="$t('global.starttestrun')"
    :knopf-satz="$t('global.createsrunwithfictitiousentriesonlyinlog')"
    :knopf-anforderung="anforderung"
    docs-name="testablauf"
  >
    <!-- Das Formular für die Parameter aus G3; der Knopf des Rahmens startet mit diesen Angaben -->
    <template #stand>
      <div class="mt-3">
        <div class="row">
          <div class="col-xl-3">
            <div class="form-group">
              <select v-model="laufart" class="form-control">
                <option value="zeigen">{{ $t("global.showrunningrun") }}</option>
                <option value="warten">{{ $t("global.waitiflocked") }}</option>
                <option value="einzeln">{{ $t("global.singleoneobject") }}</option>
              </select>
              <label>{{ $t("global.runtype") }}</label>
            </div>
          </div>
          <template v-if="laufart === 'einzeln'">
            <div class="col-xl-3">
              <div class="form-group">
                <select v-model="objektArt" class="form-control">
                  <option value="auftrag">{{ $t("global.order") }}</option>
                  <option value="person">{{ $t("global.person") }}</option>
                  <option value="firma">{{ $t("global.company") }}</option>
                </select>
                <label>{{ $t("global.objecttype") }}</label>
              </div>
            </div>
            <div class="col-xl-3">
              <div class="form-group">
                <input v-model.trim="objektId" class="form-control" type="text" placeholder=" " />
                <label>{{ $t("global.objectid") }}</label>
              </div>
            </div>
          </template>
        </div>

        <div class="row">
          <div v-for="feld in zahlFelder" :key="feld.key" class="col-xl-2">
            <div class="form-group">
              <input v-model.number="parameter[feld.key]" class="form-control" type="number" min="0" placeholder=" " />
              <label>{{ $t(feld.schluessel) }}</label>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-xl-2">
            <div class="form-check">
              <input id="testablauf-fehlschlag" v-model="parameter.fehlschlag" type="checkbox" class="form-check-input" />
              <label for="testablauf-fehlschlag">{{ $t("global.failure") }}</label>
            </div>
          </div>
          <div class="col-xl-2">
            <div class="form-check">
              <input id="testablauf-zeitplan" v-model="parameter.zeitplan" type="checkbox" class="form-check-input" />
              <label for="testablauf-zeitplan">{{ $t("global.asfromschedule") }}</label>
            </div>
          </div>
          <div class="col-xl-2">
            <div class="form-check">
              <input id="testablauf-test" v-model="test" type="checkbox" class="form-check-input" />
              <label for="testablauf-test">{{ $t("global.testrun") }}</label>
            </div>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col-xl-3">
            <div class="form-group mb-0">
              <input v-model.trim="laufId" class="form-control" type="text" placeholder=" " @keyup.enter="laufOeffnen" />
              <label>{{ $t("global.runid") }}</label>
            </div>
          </div>
          <div class="col-xl-3">
            <button type="button" class="btn btn-default" :disabled="!laufId" @click="laufOeffnen">
              {{ $t("global.openrun") }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </ablauf-seite>
</template>

<script>
import page from "@/mixins/Page";
import AblaufSeite from "@/components/Lauf/AblaufSeite.vue";

/**
 * Seite des Testablaufs lauf.test im Rahmen für die Seite je Ablauf (G3, ab G4 im Rahmen, Konzept 12.7). Der
 * Knopf des Rahmens startet die gewählte Laufart, ohne Wahl „zeigen“: läuft schon ein Lauf, zeigt die
 * Lauf-Ansicht diesen. Nur nutzbar, wo lauf.test angemeldet ist (edu-dev, edu-staging).
 */
export default {
  name: "Testablauf",
  components: {
    AblaufSeite,
  },
  mixins: [page],
  data() {
    return {
      laufart: "zeigen",
      objektArt: "auftrag",
      objektId: "",
      test: false,
      laufId: "",
      parameter: {
        anzahl: 10,
        fehler: 0,
        nichtVerarbeitet: 0,
        markiert: 0,
        dauerSekunden: 0,
        fehlschlag: false,
        zeitplan: false,
      },
      zahlFelder: [
        { key: "anzahl", schluessel: "global.numberofentries" },
        { key: "fehler", schluessel: "global.ofwhichwitherror" },
        { key: "nichtVerarbeitet", schluessel: "global.ofwhichnotprocessed" },
        { key: "markiert", schluessel: "global.ofwhichmarked" },
        { key: "dauerSekunden", schluessel: "global.durationinseconds" },
      ],
    };
  },
  computed: {
    navbarTitel() {
      return this.$t("global.testworkflow");
    },
    /** Was der Knopf des Rahmens zu Ablauf und Laufart mitschickt */
    anforderung() {
      const einzeln = this.laufart === "einzeln";
      return {
        objektArt: einzeln ? this.objektArt : null,
        objektId: einzeln ? this.objektId : null,
        test: this.test,
        parameter: this.parameter,
      };
    },
  },
  methods: {
    laufOeffnen() {
      if (!this.laufId) return;
      this.$bus.$emit("lauf-ansicht-oeffnen", { lauf: this.laufId });
    },
  },
};
</script>
